import { render } from "./NoticeManage.vue?vue&type=template&id=f5643544&scoped=true"
import script from "./NoticeManage.vue?vue&type=script&lang=js"
export * from "./NoticeManage.vue?vue&type=script&lang=js"

import "./NoticeManage.vue?vue&type=style&index=0&id=f5643544&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5643544"]])

export default __exports__